document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".hm-read-more-container").forEach(function(container) {
    var content = container.querySelector(".hm-read-more-content");
    var toggle = container.querySelector(".hm-read-more-toggle");

    content.style.display = "none"; // hide extra content initially

    toggle.addEventListener("click", function(e) {
        e.preventDefault();
        // Use computed style to check if it's currently visible
        if (window.getComputedStyle(content).display === "none") {
            content.style.display = "block";
            toggle.textContent = "Read Less";
        } else {
            content.style.display = "none";
            toggle.textContent = "Read More";
        }
    });
});
  const container = document.querySelector('.collection-hero__description.rte');
  const maxHeight = 150;

  if (!container) return;

  // 1. Inject ALL styles via JS
  const style = document.createElement('style');
  style.innerHTML = `
    .desc-truncated {
      max-height: ${maxHeight}px;
      overflow: hidden;
      mask-image: linear-gradient(to bottom, black 80%, transparent 100%);
      -webkit-mask-image: linear-gradient(to bottom, black 80%, transparent 100%);
    }

    .desc-expanded {
      max-height: none;
      overflow: visible;
      mask-image: none;
      -webkit-mask-image: none;
    }

    body.template-collection .read-more-btn {
      display: none;
      margin-top: 10px;
      cursor: pointer;
      color: #000;
      font-weight: 600;
      text-decoration: underline;      
      width:100%;
    }

    body.template-collection .read-more-btn.is-visible {
      display: inline-block;
      text-align:left !important;
    }
  `;
  document.head.appendChild(style);

  // 2. Create button
  const btn = document.createElement('div');
  btn.className = 'read-more-btn';
  btn.innerText = 'Read More';

  container.insertAdjacentElement('afterend', btn);

  // 3. Initial check
  function applyTruncation() {
    if (container.scrollHeight > maxHeight) {
      container.classList.add('desc-truncated');
      container.classList.remove('desc-expanded');
      btn.classList.add('is-visible');
      btn.innerText = 'Read More';
    } else {
      container.classList.remove('desc-truncated');
      container.classList.remove('desc-expanded');
      btn.classList.remove('is-visible');
    }
  }

  applyTruncation();

  // 4. Toggle behavior (clean fix)
  btn.addEventListener('click', () => {
    const isExpanded = container.classList.contains('desc-expanded');

    if (isExpanded) {
      // Collapse
      container.classList.remove('desc-expanded');
      container.classList.add('desc-truncated');
      btn.innerText = 'Read More';
    } else {
      // Expand
      container.classList.remove('desc-truncated');
      container.classList.add('desc-expanded');
      btn.innerText = 'Read Less';
    }
  });

  // 5. Handle resize (keeps it responsive)
  window.addEventListener('resize', applyTruncation);
});

document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".product-card").forEach(function (card) {

    const variantsEl = card.querySelector(".product-variants");
    const sizeSelect = card.querySelector(".product-card__size-select");
    const priceEl = card.querySelector(".product-card__price-value");

    if (!variantsEl || !sizeSelect || !priceEl) return;

    const variants = JSON.parse(variantsEl.textContent);

    sizeSelect.addEventListener("change", function () {

      const selectedSize = this.value;

      const matchedVariant = variants.find(v =>
        v.option1 === selectedSize
      );

      if (matchedVariant) {

        // Shopify currency-safe format
        if (window.Shopify && Shopify.formatMoney) {
          priceEl.innerHTML = Shopify.formatMoney(matchedVariant.price);
        } else {
          priceEl.innerHTML = (matchedVariant.price / 100).toFixed(2);
        }

      }

    });

  });

});

// Wholsale Enquiry Form Design
window.addEventListener("load", () => {
  // Run only on Wholesale Inquiry page
  if (!document.body.classList.contains("page-wholesale-inquiry")) {
    return;
  }

  const injectStyles = () => {
    const widget = document.querySelector("powr-form-builder");

    if (!widget?.shadowRoot) return false;

    // Prevent duplicate injection
    if (widget.shadowRoot.querySelector("#custom-powr-style")) {
      return true;
    }

    const style = document.createElement("style");

    style.id = "custom-powr-style";

    style.textContent = `
        a[href*="powr.io/form-builder"] {
          display: none !important;
        }
        .form-container {
          border: 1px solid #525c4b !important;
          box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px !important;
          overflow: hidden !important;
        }

        .form-container h1 {
          font-size: 38px !important;
          margin-bottom: 36px !important;
          background: #525c4b;
          color: #fff !important;
          text-box-trim: none;
          line-height: 1.8 !important;
        }
        .form-container .form-content-wrapper {
          padding-inline: 0px !important;
        }

        .form-container .form-content-wrapper form {
          padding-inline: 40px !important;
        }
        .form-container .form-content-wrapper > div {
          padding-top: 0 !important;
          margin: 0 !important;
        }
        .form-container .form-content-wrapper button[type="button"] {
          background: #525c4b !important;
        }
        
        .form-container hr.border-gray-300 {
            border: none !important;
            margin: 0 !important;
            display:none !important
          }

        @media(max-width: 576px) {
          .form-container .form-content-wrapper form {
            padding-inline: 20px !important;
          }

          .form-container h1 {
            padding-block: 10px !important;
            font-size: 24px !important;
          }
        }
    `;

    widget.shadowRoot.appendChild(style);

    return true;
  };

  // Initial attempt
  if (injectStyles()) return;

  // Observe future DOM changes
  const observer = new MutationObserver(() => {
    if (injectStyles()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
